import styled from 'styled-components';

import { GoogleMapProps } from './types';

export const Row = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const StyledMap = styled.div<Pick<GoogleMapProps, 'height'>>(({ height }) => ({
  width: '100%',
  height: height,
  borderRadius: '16px',
  visibility: 'visible',
}));

export const Mask = styled.div<Pick<GoogleMapProps, 'disabled' | 'height'>>(({ height, disabled }) => ({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  height,
  width: '100%',
  backgroundColor: 'black',
  opacity: 0.3,
  borderRadius: '16px',
  ...(!disabled && { display: 'none' }),
}));

export const MaskWrapper = styled.div<Pick<GoogleMapProps, 'height'>>(({ height }) => ({
  position: 'relative',
  height,
  width: '100%',
}));

export const MaskLabelWrapper = styled.div<{ disabled?: boolean }>(({ disabled }) => ({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  ...(!disabled && { display: 'none' }),
}));
